import React from "react";
import { useTranslate } from "../../../../components/TranslationText";
import SearchBox from "../../../../components/SearchBox";
import { EmbryoPermitStatus } from "../../../../constants/serviceListConstants";

/**
 * Filter bar with shared SearchBox and status dropdown for Embryo Transfer Permits.
 *
 * @param {Object} props
 * @param {string} props.searchTerm - Current search term
 * @param {Function} props.onSearchChange - Search term change callback
 * @param {string} props.selectedStatus - Current selected status filter
 * @param {Function} props.onStatusChange - Status change callback
 * @param {Function} [props.onSearchSubmit] - Search submit callback
 */
export default function EmbryoPermitFilter({
    searchTerm = "",
    onSearchChange,
    selectedStatus = "all",
    onStatusChange,
    onSearchSubmit,
}) {
    const { translate } = useTranslate();

    return (
        <div className="row rtl mb-main align-items-center">
            {/* Shared SearchBox Component */}
            <div className="col-sm-6 col-12">
                <SearchBox
                    isFullWidth
                    isForm={false}
                    isWithSubmitBTN={true}
                    onSubmitBtnFunction={onSearchSubmit}
                    onChange={onSearchChange}
                    value={searchTerm}
                    placeholder={translate(
                        "web.searchByKeyword",
                        "Search By Keyword"
                    )}
                />
            </div>

            {/* Status Dropdown */}
            <div className="col-sm-4 col-12 mb-form-group">
                <select
                    className="form-select form-control"
                    value={selectedStatus}
                    onChange={(e) => onStatusChange(e.target.value)}
                    style={{ height: 35, fontSize: "14px" }}
                >
                    <option value="all">{translate("web.all", "All")}</option>
                    <option value={EmbryoPermitStatus.Active}>{translate("web.actives", "Active")}</option>
                    <option value={EmbryoPermitStatus.Expired}>{translate("web.expired", "Expired")}</option>
                </select>
            </div>
        </div>
    );
}
